import "./Button.css";
export default function Button({variant="primary",size="base",children,className="",...rest}){
    const cls=`btn btn-${variant} ${size==="sm"?"btn-sm":""} ${className}`;
    return <button className={cls} {...rest}>{children}</button>;
}
